var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-list-input',_vm._g(_vm._b({staticClass:"notes",attrs:{"type":"texteditor","placeholder":_vm.autoSave ? _vm.$t('placeholder-autosave') : _vm.$t('placeholder'),"value":_vm.object ? _vm.object.notesHtml : '',"text-editor-params":{
    mode: 'keyboard-toolbar',
    buttons: ['bold', 'italic', 'underline', 'strikeThrough'],
    clearFormattingOnPaste: false
  },"resizable":""},on:{"change":_vm.change,"blur":_vm.blur}},'f7-list-input',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }